module.exports = __webpack_public_path__ + "img/virement_bancaire.3700b8ae.png";